import './B2BDialog.css';

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider } from '@mui/material';
import { generateClassName } from './helpers';
import CustomButton from './CustomButton';

const B2BDialog = ({ open, onClose, title, children, className, buttons }) => {
    return (
        <Dialog open={open} onClose={onClose} className={generateClassName("b2b-dialog", "", className)}>
            <DialogTitle className={generateClassName("b2b-dialog", "-title", className)}>{title}</DialogTitle>
            <DialogContent className={generateClassName("b2b-dialog", "-content", className)}>
                {children}
            </DialogContent>
            <DialogActions className={generateClassName("b2b-dialog", "-actions", className)}>
                {buttons && (<Divider orientation='horizontal' flexItem variant='fullWidth' />)}
                {buttons && buttons.map((button, index) => (
                    <CustomButton key={index}
                        {...button}>
                        {button.label}
                    </CustomButton>
                ))}
            </DialogActions>
        </Dialog>
    );
};

export default B2BDialog;